import eventEmitter, { GameEvents } from '../../pages/Home/eventEmiter';

export const aviatorFileList = [
  {
    name: 'aviatorSkins',
    jsonPath: 'aviator/aviatorSkins/Aviator.json',
    atlasPath: 'aviator/aviatorSkins/Aviator.atlas',
    skins: ['default'],
    attachments: ['default'],
    animations: [null],
  },
  {
    name: 'background',
    jsonPath: 'aviator/looped_bg/background.json',
    atlasPath: 'aviator/looped_bg/background.atlas',
    skins: ['default'],
    attachments: ['default'],
    animations: [null],
  },
  {
    name: 'racoon',
    jsonPath: 'aviator/racoon/racoon.json',
    atlasPath: 'aviator/racoon/racoon.atlas',
    skins: ['default'],
    attachments: ['default'],
    animations: ['racoon', 'racoon_fly1', 'racoon_fly2', 'racoon_fly3'],
  },
  {
    name: 'sun',
    jsonPath: 'aviator/sun/sun.json',
    atlasPath: 'aviator/sun/sun.atlas',
    skins: ['default'],
    attachments: ['default'],
    animations: [null],
  },
  {
    name: 'ufo',
    jsonPath: 'aviator/ufo/ufo.json',
    atlasPath: 'aviator/ufo/ufo.atlas',
    skins: ['default'],
    attachments: ['default'],
    animations: ['ufo', 'ufo_fly_1', 'ufo_fly_2', 'ufo_fly_3'],
  },
  {
    name: 'planet',
    jsonPath: 'aviator/planet/planet.json',
    atlasPath: 'aviator/planet/planet.atlas',
    skins: ['default'],
    attachments: ['default'],
    animations: ['planet', 'planet_fly', 'planet_fly2', 'planet_fly3'],
  },
  {
    name: 'coins_shower',
    jsonPath: 'overlay/coins/coins.json',
    atlasPath: 'overlay/coins/coins.atlas',
    skins: ['default'],
    attachments: ['default'],
    animations: [null],
  },
] as const;

export class PreloadScene extends Phaser.Scene {
  constructor() {
    super({ key: 'PreloadScene' });
  }

  preload() {
    this.load.setPath(`${window.location.origin}/spine`);
    aviatorFileList.forEach((file) => {
      this.load.spine(file.name, file.jsonPath, file.atlasPath);
    });
    this.load.on('complete', () => {
      eventEmitter.emit(GameEvents.PRELOAD_LOADED);
    });
    this.events.on('shutdown', () => {
      this.children.removeAll();
    });
  }
}
